// Phase 15 Plan 05 Task 2 — Per-ladder LeaderboardResponse cache (60s TTL).
//
// Mirrors profileCache.ts conventions. Key is `ladderKey` (e.g. "std-en",
// "open-sv", etc. — see LadderKey schema). TTL 60s matches the server-side
// KV cache TTL so a tab switch within the same window doesn't double-spend
// the cache.
//
// In-memory only — `map()` (NOT `persistentMap`). Page reload re-fetches.

import { map } from 'nanostores'
import type { LeaderboardResponse } from '../net/leaderboard'

interface CacheEntry {
  readonly data: LeaderboardResponse
  readonly expires_at: number
}

export const LEADERBOARD_CACHE_TTL_MS = 60_000

export const $leaderboardCache = map<Record<string, CacheEntry | undefined>>({})

export function setCachedLeaderboard(
  ladderKey: string,
  data: LeaderboardResponse,
): void {
  $leaderboardCache.setKey(ladderKey, {
    data,
    expires_at: Date.now() + LEADERBOARD_CACHE_TTL_MS,
  })
}

export function getCachedLeaderboard(
  ladderKey: string,
): LeaderboardResponse | null {
  const entry = $leaderboardCache.get()[ladderKey]
  if (!entry) return null
  if (entry.expires_at < Date.now()) return null
  return entry.data
}

export function invalidateLeaderboardCache(ladderKey: string): void {
  $leaderboardCache.setKey(ladderKey, undefined)
}
